// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import CheckinController from "./checkin_controller";
application.register("checkin", CheckinController);

import ClickableRowController from "./clickable_row_controller";
application.register("clickable-row", ClickableRowController);

import DismissibleController from "./dismissible_controller";
application.register("dismissible", DismissibleController);

import DiscountFormController from "./discount_form_controller";
application.register("discount-form", DiscountFormController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import FilterFormController from "./filter_form_controller";
application.register("filter-form", FilterFormController);

import FormValidationController from "./form_validation_controller";
application.register("form-validation", FormValidationController);

import NestedFormController from "./nested_form_controller";
application.register("nested-form", NestedFormController);

import PaymentLinkController from "./payment_link_controller";
application.register("payment-link", PaymentLinkController);

import OtherPriceController from "./other_price_controller";
application.register("other-price", OtherPriceController);

import SidebarController from "./sidebar_controller";
application.register("sidebar", SidebarController);

import TabController from "./tab_controller";
application.register("tab", TabController);

import ThemeToggleController from "./theme_toggle_controller";
application.register("theme-toggle", ThemeToggleController);
